import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, subtitle }) => (
  <Reveal>
    <p className="font-mono text-xs uppercase tracking-[0.35em] text-terracotta">{eyebrow}</p>
    <h2 className="mt-4 font-serif text-4xl leading-tight text-ink sm:text-5xl">{title}</h2>
    {subtitle && (
      <p className="mt-5 max-w-2xl leading-relaxed text-taupe">{subtitle}</p>
    )}
  </Reveal>
);

export default Reveal;
